import { differenceInYears } from 'date-fns/fp'

export default (dateOfBirth: string): number => {
  const dob = new Date(dateOfBirth)
  const today = new Date()
  return differenceInYears(dob, today)
}
